import { useState } from "react";
import { useLocale } from "../lib/i18n";

const CONSENT_KEY = "nigunim:cookieConsent";
const CLARITY_PROJECT_ID = "wg5h83pv2e";
const COOKIE_BANNER_ENABLED = true;

export function CookieConsent() {
  const { t } = useLocale();
  const [visible, setVisible] = useState(() => !localStorage.getItem(CONSENT_KEY));

  if (!COOKIE_BANNER_ENABLED) return null;
  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    // Load Clarity dynamically without page reload
    if (!(window as any).clarity) {
      (function(c: any,l: any,a: string,r: string,i: string){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        const t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        const y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window,document,"clarity","script",CLARITY_PROJECT_ID);
    }
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-20 left-3 right-3 z-50 mx-auto max-w-[420px] backdrop-blur rounded-xl px-4 py-3 shadow-lg animate-slide-up"
      style={{
        background: "rgba(11, 31, 74, 0.95)",
        border: "1px solid rgba(212, 162, 74, 0.3)",
        color: "var(--parchment-soft)",
      }}
    >
      <p
        className="mb-3"
        style={{ fontFamily: "'Heebo', sans-serif", fontSize: 13, lineHeight: 1.45 }}
      >
        {t("cookie.message")}
      </p>
      <div className="flex gap-2">
        <button
          onClick={handleDecline}
          className="flex-1 py-2 rounded-lg transition-opacity hover:opacity-100"
          style={{
            fontFamily: "'Heebo', sans-serif",
            fontSize: 13,
            fontWeight: 500,
            color: "var(--parchment-soft)",
            opacity: 0.7,
            border: "1px solid rgba(250, 245, 232, 0.15)",
          }}
        >
          {t("cookie.decline")}
        </button>
        <button
          onClick={handleAccept}
          className="flex-1 py-2 rounded-lg"
          style={{
            fontFamily: "'Heebo', sans-serif",
            fontSize: 13,
            fontWeight: 700,
            color: "#2a1a00",
            background: "linear-gradient(180deg, var(--gold-400), var(--gold-500))",
          }}
        >
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  );
}
